import type { ComponentType } from 'react';
import type { LucideProps } from 'lucide-react';
import {
  Anchor,
  Cpu,
  HeartHandshake,
  ShieldCheck,
  ShieldPlus,
  Sparkles,
  SunMedium,
  Users,
  Stethoscope,
} from 'lucide-react';

const iconMap: Record<string, ComponentType<LucideProps>> = {
  Anchor,
  Cpu,
  HeartHandshake,
  ShieldCheck,
  ShieldPlus,
  Sparkles,
  SunMedium,
  Users,
};

interface ServiceIconProps extends LucideProps {
  name: string;
}

export function ServiceIcon({ name, ...props }: ServiceIconProps): JSX.Element {
  const IconComponent = iconMap[name] ?? Stethoscope;
  return <IconComponent {...props} />;
}
